import { render } from "./Index_affix_en.vue?vue&type=template&id=41a45151"
import script from "./Index_affix_en.vue?vue&type=script&lang=js"
export * from "./Index_affix_en.vue?vue&type=script&lang=js"

import "./Index_affix_en.vue?vue&type=style&index=0&id=41a45151&lang=css"
script.render = render

export default script